import { Component, effect, inject, OnInit } from '@angular/core';
import { ThemeService } from '@core/theme/theme.service';
import { OverlayContainer } from '@angular/cdk/overlay';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Dentapp';

  #themeService = inject(ThemeService);
  #overlayContainer = inject(OverlayContainer);

  constructor() {
    effect(() => {
      const theme = this.#themeService.theme();
      this.applyTheme(theme);
    });
  }

  ngOnInit(): void {
    const theme = this.#themeService.theme();
    this.applyTheme(theme);
  }

  private applyTheme(theme: string) {
    const htmlEl = document.documentElement;
    // Remove all theme classes
    htmlEl.classList.forEach((cls) => {
      if (cls.endsWith('-light') || cls.endsWith('-dark')) {
        htmlEl.classList.remove(cls);
      }
    });
    htmlEl.classList.add(theme);

    // Sync overlay container (dialogs, menus, etc.)
    const overlayEl = this.#overlayContainer.getContainerElement();
    overlayEl.classList.forEach((cls) => {
      if (cls.endsWith('-light') || cls.endsWith('-dark')) {
        overlayEl.classList.remove(cls);
      }
    });
    overlayEl.classList.add(theme);
  }
}
